import api from "../util/api";


const attendanceApi = {

    getCalendar(month, year) {

        

        return api.get("/attendance/calendar", {

            params: {

                month,

                year

            }

        });

    },

    getDay(date) {

        return api.get(`/attendance/day/${date}`);

    },

    search(keyword) {

        return api.get("/attendance/search", {

            params: {

                keyword

            }

        });

    },

    getSummary(month, year) {

         let response  = api.get("/attendance/month-summary", {

            params: {

                month,

                year

            }

        }); 

        


        

        return response;

    },

    async getActiveSessions() {

    return api.get(
        "/attendance/active-sessions"
    );

},


async selfMark(data) {

    return api.post(
        "/attendance/self-mark",
        data
    );

}

    

};

export default attendanceApi;